/**
 * @ignore
 * todo: remove this file (needed for CLI?)
 */
const config = {
  network: {
    layer1: 'placeholder',
  },
  logLevel: 'debug',
};

export { config };
